module.exports = __webpack_public_path__ + "assets/media/evening.1f6926fe.mp3";